export const outOfGameReasons = {
  NA: "N/A",
  VACATION: "Vacation",
  YEAR_LONG: "Year-long student",
  THREE_MISSED_CHECK_INS: "Three missed noon check-ins",
  PERMANENT: "Permanent (three knock-outs)",
  OPTED_OUT: "Student opted out of the game",
  OTHER: "Other",
};
